type CheckboxProps = {
	id: string;
	name: string;
	value: string;
	checked: boolean;
	label: string;
	classes: {
		checkbox_input?: string;
		checkbox_label?: string;
		checkbox_checked?: string;
	};
	onClick?: (v: string) => void;
	readonly?: boolean;
	isDisabled?: boolean;
};

const Checkbox = ({ id, name, value, checked, label, classes, onClick, readonly, isDisabled }: CheckboxProps) => {
	const handleOnChange = (selectedValue: string) => {
		if (onClick) {
			onClick(selectedValue);
		}
	};
	return (
		<>
			<input
				type="checkbox"
				onChange={() => handleOnChange(id)}
				data-testid={id}
				id={id}
				name={name}
				value={value}
				className={classes?.checkbox_input}
				readOnly={readonly}
				checked={checked}
				disabled={isDisabled}
			/>
			<label htmlFor={id} className={`${classes?.checkbox_label} ${checked ? classes?.checkbox_checked : ""}`}>
				{label}
			</label>
		</>
	);
};

export default Checkbox;
